// extracted by css-extract-rspack-plugin
export default {"labelText":"ConfirmCloseDialog-module__labelText__Wa_4YjD"};